<template>
  <main-layout>
    <loading-screen v-if="isLoading" />
    <div>
      <check-circle
        v-if="parameter === 'Success'"
        scale="4"
        color="red"
      />
      <exclamation-circle
        v-if="parameter === 'IsConfirmed'"
        scale="4"
        color="red"
      />
    </div>
    <h2>
      {{ title }}
    </h2>
    <p class="font-weight-bold">
      {{ description }}
    </p>
    <div>
      <button
        class="button"
        @click="$router.push({ name: 'SetNumber' })"
      >
        Salir
      </button>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/components/MainLayout';
import { CheckCircle, ExclamationCircle } from '@/components/icons';
import phoneFormatter from '@/utils/phoneFormatter';

export default {
  name: 'AffiliationResult',
  components: { MainLayout, CheckCircle, ExclamationCircle },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    parameter() {
      return this.$route.query.result || 'NotFound';
    },
    serviceId() {
      return phoneFormatter(this.$route.query.serviceId) || '';
    },
    card() {
      return this.$route.query.cardLast4Digits || '';
    },
    title() {
      return this.$t(`affiliationResult.${this.parameter}.title`) || '';
    },
    description() {
      return this.$t(`affiliationResult.${this.parameter}.description`, { serviceId: this.serviceId, card: this.card });
    }
  }
};
</script>

